import {makeStyles, Theme} from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
    responsiveImg: {
        maxWidth: "100%",
    },
    containerImage: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    uploadContainer: {
        width: "100%",
    },
    buttonsSignature: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: `${theme.spacing(2)}px`,
    },
    signatureButtons: {
        margin: `${theme.spacing(2)}px`,
        marginTop: `${theme.spacing(6)}px`,
        marginBottom: `${theme.spacing(6)}px`,
    },
    signatureTitle: {
        margin: `${theme.spacing(2)}px`,
        marginTop: `${theme.spacing(6)}px`,
        marginBottom: `${theme.spacing(6)}px`,
        width: "100%",
        textAlign: "center",
    },
    warningBox: {
        backgroundColor: `#ff5722`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: `${theme.spacing(3)}px`,
        margin: `${theme.spacing(3)}px`,
    },
}));
export default useStyles;